<template>
	<!-- 咨询建议-意见反馈 详情与编辑 弹窗开始 -->
	<div class="detailWap" id="view02">
	  <div class="rightWap">
	    <div class="message" v-loading="loadingMask">
	      <h1>详情<img src="/images/rightClose.png" class="closePop1" @click="closeFloat"/></h1>
	      <div class="form">
	        <dl class="messageForm">
	          <dt>反馈类型</dt>
	          <dd>
	            <input v-if="!isedit" type="text" v-model="fankuiform.type" disabled id="bb2"/>
	            <div v-else id="bb4" style="margin-left: -20px;">
	              <input v-model="fankuiform.type" value="功能异常" :style="{'pointer-events':isedit==0?'none':''}" type="radio" name="a" style="margin-left: 20px"/> 功能异常
	              <input v-model="fankuiform.type" value="产品建议" :style="{'pointer-events':isedit==0?'none':''}" type="radio" name="a" style="margin-left: 40px"/> 产品建议
	              <input v-model="fankuiform.type" value="其他" :style="{'pointer-events':isedit==0?'none':''}" type="radio" name="a" style="margin-left: 40px"/> 其他
	            </div>
	          </dd>
	          <dt>反馈内容</dt>
	          <dd>
	            <div class="textareaWap">
	              <textarea id="bb1" rows="10" maxlength="300" style="resize: none;" v-model="fankuiform.desc" :readonly="!isedit"></textarea>
	              <div id="t2">
	                <div style="text-align: right; padding-right: 24px;"><span>{{fankuiform.desc.length}}/300</span></div>
	                <div style="padding: 24px">
	                	<div style="position: relative;" v-show="isedit">
	                		<img src="/images/photo.png"/>
	                		<input type="file" id="file" accept="image/*" v-on:change="uploadFile" style="opacity: 0;width: 80px;height: 80px;cursor: pointer;position: absolute;left: 0;"/>
	                	</div>
	                	<div v-for="(item,index) in fankuiatts" class="pic" style="position: relative;">
	                		<img v-bind:src="item.image"  style="max-width: 100%;"  alt=""/>
	                		<img src="/images/rightClose.png" v-show="isedit" @click="delFile(item.attId)" style="position: absolute;left: 16px;top: 16px;"/>
	                	</div>
	                  <div v-show="isedit" style="color: #d9d9d9; padding-top: 24px;">单张图片最大可上传大小为1MB</div>
	                </div>
	              </div>
	            </div>
	          </dd>          
	          <dt>联系电话</dt>
	          <dd><input type="text" v-model="fankuiform.phone"  :readonly="!isedit" id="bb3"/></dd>
	        </dl>
	        <div style="text-align: right">
	          <input type="button" v-if="!isedit"  @click="isedit=1" value="修改" class="messageSub" id="edit02"/>
	          <input type="button" v-else @click="updatefankui" value="保存" class="messageSub" id="save02"/>
	        </div> 
	      </div> 
	    </div>
	  </div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask:true,
				isedit:0,
				fankuiDetail:'',
				fankuiform: {
					desc: '',
					type:'',
					phone:''
				},
				fankuiatts:[],
			}
		},
		props:[
			'detailid'
		],
		mounted: function() {
			this.getFankuiDetailfnc();
			this.$track([
				['pagetype','查看建议反馈']
			]);
		},
		methods: {
			getFankuiDetailfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'UserInfo/GetUserFeedback',
						responseType: 'json',
						params: {
							id: this.detailid,
						},
					})
					.then(function(response) {
						_this.fankuiDetail = response.data.data.data.feedback;
						var fankuiContent= JSON.parse(_this.fankuiDetail.content);
						_this.fankuiform.desc=fankuiContent.desc;
						_this.fankuiform.type=fankuiContent.type;
						_this.fankuiform.phone=fankuiContent.phone;
						var tempatts=response.data.data.data.att;
						var tempimages=response.data.data.data.images;
						for(var i=0;i<tempatts.length;i++){
							_this.fankuiatts.push({
								attId:tempatts[i].id,
								fileName:tempatts[i].filename,
								image:tempimages[tempatts[i].id]
							})
						}
						_this.$track([
							['pagetype','查看建议反馈详情']
						]);
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			updatefankui:function(){
				if(!this.fankuiform.desc){
					this.$message({
						message: '请填写描述',
						type: 'warning'
					});
					
					return false;
				}
				else if (!this.fankuiform.type){
					this.$message({
						message: '请选择类型',
						type: 'warning'
					});
					
					return false;
				}
				
				if(this.fankuiform.phone){
					var regmobile=/^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					var regtel=/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
					var regemail=/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if((!regmobile.test(this.fankuiform.phone))&&(!regtel.test(this.fankuiform.phone))&&(!regemail.test(this.fankuiform.phone))){
						this.$message({
							message: '请填写正确的联系方式,如邮箱、手机号、固定电话请添加区号',
							type: 'warning'
						});
						return false;
					}
				}
				
				var tempfankui={
					type:this.fankuiform.type,
					desc:this.fankuiform.desc,
					phone:this.fankuiform.phone
				}
				var tempAttidArr=[];
				var tempAttnameArr=[];
				for(var i=0;i<this.fankuiatts.length;i++){
					tempAttidArr.push(this.fankuiatts[i].attId);
					tempAttnameArr.push(this.fankuiatts[i].fileName);
				}
				let _this = this;
				this.$http({
						method: 'post',
						url: 'UserInfo/UpdateUserFeedback',
						responseType: 'json',
						params: {
							id:this.detailid,
							content: JSON.stringify(tempfankui),
							atts:tempAttidArr.length>0?tempAttidArr.join(','):'',
							filenames:tempAttnameArr.length>0?tempAttnameArr.join(','):'',
						},
					})
					.then(function(response) {
						if(response.data.code==20000){
							_this.$message({
								message: '建议反馈修改成功',
								type: 'success'
							});
							_this.fankuiform.desc='';
							// _this.fankuiform.type='';
							_this.fankuiform.phone='';
							_this.closeFloat();
							_this.$track([
								['pagetype','修改建议反馈']
							]);
						}
						else{
							_this.$message({
								message: '建议反馈修改失败',
								type: 'error'
							});
						}
						
					})
					.catch(function(error) {
						_this.$message({
							message: '建议反馈修改失败',
							type: 'error'
						});
						// _this.closeFloat();
						console.log(error);
					});
			},
			uploadFile:function(event){
				if(event.target.files.length>0){
					var upfile=event.target.files[0];
					var formdata=new FormData();
					formdata.append('file',upfile);
					let _this = this;
					this.$http({
							method: 'post',
							url: 'UserInfo/UploadFile',
							data: formdata,
							headers: {
							  'Content-Type': 'multipart/form-data'
							}
						})
						.then(function(response) {
							if(response.data.code==20000){
								_this.fankuiatts.push(response.data.data.data);
								_this.$message({
									message: '上传成功',
									type: 'success'
								});
							}
							else{
								_this.$message({
									message: '上传失败:'+response.data.data.msg,
									type: 'error'
								});
							}
			
						})
						.catch(function(error) {
							_this.$message({
								message: '上传错误:'+response.data.data.msg,
								type: 'error'
							});
							// _this.closeFloat();
							console.log(error);
						});
				}
				
			},
			delFile:function(id){
				for(var i=0;i<this.fankuiatts.length;i++){
					if(this.fankuiatts[i].attId==id){
						this.fankuiatts.splice(i,1);
						break;
					}
				}
			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			
		},
	}
</script>

<style>
</style>
